import { ChangeEvent, InputEvent, MouseEvent, TouchEvent } from "react";
import { useTranslation } from "react-i18next";

import css from "./zoom.module.scss";

const WIDTHS = [7, 15, 30, 45, 60, 100] as const;

type ZoomProps = {
  dayWidth: number;
  setDayWidth: (dayWidth: number) => void;
};

export const Zoom = ({ dayWidth, setDayWidth }: ZoomProps) => {
  const { t } = useTranslation();
  const val = WIDTHS.indexOf(dayWidth as (typeof WIDTHS)[number]);

  const handleValueChange = (
    e:
      | ChangeEvent<HTMLInputElement>
      | InputEvent<HTMLInputElement>
      | MouseEvent<HTMLInputElement>
      | TouchEvent<HTMLInputElement>
  ) => {
    const target = e.target as HTMLInputElement;
    setDayWidth(WIDTHS[target.value as unknown as number]);
  };

  return (
    <div className={css.wrap}>
      <div className={css.push} />

      <div className={css.box}>
        <input
          type="range"
          title={t("zoom")}
          className={css.range}
          onMouseUp={handleValueChange}
          onTouchEnd={handleValueChange}
          onChange={handleValueChange}
          onInput={handleValueChange}
          value={(val as number | undefined) !== undefined ? val : 1}
          min={0}
          max={WIDTHS.length - 1}
          step={1}
        />
      </div>
    </div>
  );
};
